import React from 'react';
import styled from 'styled-components';
import InputGroupText from 'components/atoms/form/InputGroupText';


const getPrimaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.primary);

const getSecondaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.darkgray);

const InputWrapper = styled.div`
    display: ${props => (props.hidden ? 'none' : 'flex')};
    justify-content: flex-start;
    align-items: center;
    position: relative;
    font-family: 'Lato', sans-serif;
    font-size: 1em;
    width: 100%;

    & textarea {
        display: inline-block;
        background-color: rgba(255,255,255,1);
        font-size: inherit;
        width: 100%;
        height: 160px;
        border: 1px solid ${props => getSecondaryColor(props)};
        padding: .80em;
        color: #000;
    }

    & textarea:required {
        box-shadow: none;
    }

    & textarea:-webkit-autofill {
        box-shadow: 0 0 0 30px rgba(255,255,255,1) inset;
    }

    & textarea:focus {
        border-color: ${props => getPrimaryColor(props)};
        border-width: 2px;
    }

    & textarea:focus + div label {
        color:  ${props => getPrimaryColor(props)};
    }

    & textarea:disabled {
        color: #cbcbcb;
        cursor: not-allowed;
    }

    & *:focus {
        outline: 0;
    }
`;

const TextArea = styled.textarea`
    ${({ resize }) => {
        const { vertical, horizontal } = resize;

        let resizeRules = `
            ${vertical.min ? `min-height: ${vertical.min}px` : ''}
            ${vertical.max ? `max-height: ${vertical.max}px` : ''}
            ${horizontal.min ? `min-width: ${horizontal.min}px` : ''}
            ${horizontal.max ? `max-width: ${horizontal.max}px` : ''}`;

        if (!horizontal.allowResize && !vertical.allowResize) {
            resizeRules += 'resize: none;';
        } else if (!horizontal.allowResize) {
            resizeRules += 'resize: vertical;';
        } else if (!vertical.allowResize) {
            resizeRules += 'resize: horizontal;';
        }

        return resizeRules;
    }}
`;

const defaultResize = {
    vertical: { allowResize: true, min: null, max: null },
    horizontal: { allowResize: true, min: null, max: null }
};

const TextAreaAdmin = ({
    input = {},
    name,
    type,
    disabled = false,
    meta = {},
    required = true,
    placeholder,
    autocomplete = 'on',
    inputGroupTextAppend,
    inputGroupTextPrepend,
    hidden,
    resize = defaultResize,
    maxLength
}) => {
    const hasValue = input.value && input.value.length > 0;

    return (
        <InputWrapper meta={meta} hidden={hidden}>
            {inputGroupTextPrepend ? <InputGroupText>{inputGroupTextPrepend}</InputGroupText> : null}
            <TextArea {...input}
                className={hasValue ? 'has-value' : ''}
                name={name}
                type={type}
                required={required}
                disabled={disabled}
                placeholder={placeholder}
                autocomplete={autocomplete}
                maxLength={maxLength}
                resize={{
                    vertical: { ...defaultResize.vertical, ...resize.vertical },
                    horizontal: { ...defaultResize.horizontal, ...resize.horizontal }
                }}
            />
            {inputGroupTextAppend ? <InputGroupText>{inputGroupTextAppend}</InputGroupText> : null}
        </InputWrapper>
    );
};

export { TextAreaAdmin as default };



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/TextAreaAdmin.js